export default __webpack_public_path__ + "static/media/rota.4f138c0a.svg";